const schema = () => ({
  type: 'object',
  // title: 'اطلاعات اصلی',
  required: [],
  properties: {
    title: {
      title: 'عنوان',
      type: 'string',
    },
    // shop_id: {
    //   title: 'فروشگاه',
    //   type: 'string',
    // },
    // unit_id: {
    //   title: 'سازمان',
    //   type: 'string',
    // },
  },
});

export default schema;
